import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconNeximo from '../build/icon-neximo'

export const IconNeximo: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconNeximo} />
}

export default IconNeximo
